import { render, staticRenderFns, recyclableRender, components } from "./mescroll-top.vue?vue&type=template&id=726520c8&scoped=true&"
var renderjs
import script from "./mescroll-top.vue?vue&type=script&lang=js&"
export * from "./mescroll-top.vue?vue&type=script&lang=js&"
import style0 from "./mescroll-top.vue?vue&type=style&index=0&id=726520c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726520c8",
  null,
  false,
  components,
  renderjs
)

export default component.exports